export function myGreetingMySwiper() {
  var swiper = new Swiper('.mySwiper', {
    autoplay: {
      slidesPerView: 4,
      spaceBetween: 30,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  })
}

export function myGreetingMySwiper2() {
  var swiper = new Swiper('.mySwiper2', {
    slidesPerView: 1,
    spaceBetween: 0,
    slidesPerGroup: 1,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
  })
}

export function offerSwiper() {
  var swiper = new Swiper('.why_holidayCont', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      slidesPerView: 4,
      spaceBetween: 30,
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 600,
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  })
}

export function myGreetingElevatenew() {
  var swiper = new Swiper('.elevate-new', {
    autoplay: {
      slidesPerView: 3,
      spaceBetween: 30,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  })
}

// theme2 courosal js start//

export function myGreetingCruiseHolidays() {
  var swiper = new Swiper('.CruiseHolidays', {
    autoplay: {
      slidesPerView: 4,
      spaceBetween: 10,
      disableOnInteraction: false,
    },
    breakpoints: {
      360: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  })
}

export function myGreetingChild_featureSwiper() {
  var swiper = new Swiper('.child_featureSwiper', {
    autoplay: {
      slidesPerView: 4,
      spaceBetween: 10,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
    },
    breakpoints: {
      360: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  })
}

export function myGreetingTestimonial_data() {
  var swiper = new Swiper('.testimonial_data', {
    slidesPerView: 1,
    spaceBetween: 0,
    slidesPerGroup: 1,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
  })
}

export function myGreetingMyclientSwiper() {
  var swiper = new Swiper('.myclientSwiper', {
    autoplay: {
      slidesPerView: 6,
      spaceBetween: 10,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
    },
    breakpoints: {
      360: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
    },
  })
}

export function myGreetingOffermain() {
  var swiper = new Swiper('.offermain', {
    autoplay: {
      disableOnInteraction: false,
    },
    breakpoints: {
      360: {
        slidesPerView: 1.3,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 1.3,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  })
}

export function myGreetingNewlyadded() {
  var swiper = new Swiper('.newlyadded', {
    autoplay: {
      disableOnInteraction: false,
    },
    breakpoints: {
      360: {
        slidesPerView: 1.4,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 1.4,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
  })
}

export function myGreetingMostbooked() {
  var swiper = new Swiper('.mostbooked', {
    autoplay: {
      disableOnInteraction: false,
    },
    breakpoints: {
      360: {
        slidesPerView: 1.6,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 1.6,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
  })
}

export function myGreetingHoneymoonpkg() {
  var swiper = new Swiper('.honeymoonpkg', {
    autoplay: {
      disableOnInteraction: false,
    },
    breakpoints: {
      360: {
        slidesPerView: 3.7,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 3.7,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 7,
        spaceBetween: 10,
      },
    },
  })
}

// Explore holiday mobile

export function myGreetingExploremain() {
  var swiper = new Swiper('.exploremain', {
    autoplay: {
      disableOnInteraction: false,
    },
    breakpoints: {
      360: {
        slidesPerView: 1.3,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 1.3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  })
}

export function myGreetingBudgetSwiper() {
  var swiper = new Swiper('.budgetSwiper', {
    slidesPerView: 3,
    spaceBetween: 20,
  
    autoplay: {
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  })
}


export function myGreetingPopularSwiper() {
  const swiperContainer = document.querySelector('.popularSwiper')
  const swiperWrapper = swiperContainer?.querySelector('.swiper-wrapper')
  const slides = swiperWrapper?.querySelectorAll('.swiper-slide')
  const prevArrow = document.querySelector('.offerSwiper-button-prev')
  const nextArrow = document.querySelector('.offerSwiper-button-next')
  const isMobile = window.innerWidth <= 768

  if (slides?.length <= 4 && !isMobile) {
    swiperContainer.classList.add('static-swiper')

    if (prevArrow && prevArrow.style) {
      prevArrow.style.display = 'none'
    }


    if (nextArrow && nextArrow.style) {
      nextArrow.style.display = 'none'
    }

    slides?.forEach((slide) => {
      slide.style.flex = '0 0 289px'
      slide.style.maxWidth = '289px'
    })

    return
  } else {

    if (prevArrow && prevArrow.style) {
      prevArrow.style.display = 'flex'
    }

    if (nextArrow && nextArrow.style) {
      nextArrow.style.display = 'flex'
    }
  }

  var swiper = new Swiper('.popularSwiper', {
    loop: false,
    autoplay: false,
    slidesPerView: isMobile ? 1.5 : 4,
    spaceBetween: isMobile ? 10 : 11,
    slidesPerGroup: 1,
    navigation: {
      nextEl: '.offerSwiper-button-next',
      prevEl: '.offerSwiper-button-prev',
    },
    breakpoints: {
      280: {
        slidesPerView: 1.4,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 11,
      },
    },
  })
}

export function myGreetingNetworkslider() {
  const swiperContainer = document.querySelector('.networkslider')
  const swiperWrapper = swiperContainer?.querySelector('.swiper-wrapper')
  const slides = swiperWrapper?.querySelectorAll('.swiper-slide')
  const prevArrow = document.querySelector('.offerSwiper-button-prevs')
  const nextArrow = document.querySelector('.offerSwiper-button-nexts')
  const isMobile = window.innerWidth <= 768

  if (slides?.length <= 4 && !isMobile) {
    swiperContainer.classList.add('static-swiper')

    if (prevArrow && prevArrow.style) {
      prevArrow.style.display = 'none'
    }

    if (nextArrow && nextArrow.style) {
      nextArrow.style.display = 'none'
    }

    slides?.forEach((slide) => {
      slide.style.flex = '0 0 289px'
      slide.style.maxWidth = '289px'
    })

    return
  } else {

    if (prevArrow && prevArrow.style) {
      prevArrow.style.display = 'flex'
    }

    if (nextArrow && nextArrow.style) {
      nextArrow.style.display = 'flex'
    }
  }

  var swiper = new Swiper('.networkslider', {
    loop: false,
    autoplay: false,
    slidesPerView: isMobile ? 1.5 : 4,
    spaceBetween: isMobile ? 10 : 11,
    slidesPerGroup: 1,
    navigation: {
      nextEl: '.offerSwiper-button-nexts',
      prevEl: '.offerSwiper-button-prevs',
    },
    breakpoints: {
      280: {
        slidesPerView: 1.4,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 11,
      },
    },
  })
}


export function myGreetingCardSwiper() {
  var swiper = new Swiper('.cardSwiper', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    
    breakpoints: {
      640: {
        slidesPerView: 1,
        // spaceBetween: 11,
      },
      800: {
        slidesPerView: 2.5,
        spaceBetween: 11,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 11,
      },
    },
  })
}

export function myGreetingsliderthreeonehalf() {
  // Add delay to ensure content is fully loaded
  setTimeout(() => {
    // Get all slider containers
    const sliderContainers = document.querySelectorAll('.sliderthreeonehalf')
    
    // Initialize each slider independently
    sliderContainers.forEach((container, index) => {
      // Add unique identifier to this slider if not already present
      if (!container.dataset.swiperIndex) {
        container.dataset.swiperIndex = index
      }
      
      // Find the navigation buttons within the closest parent section
      const parentSection = container.closest('.holidays') || container.closest('[class*="section"]') || container.parentElement
      const nextButton = parentSection?.querySelector('.slider__btn__next')
      const prevButton = parentSection?.querySelector('.slider__btn__prev')
      const pagination = parentSection?.querySelector('.swiper-pagination')
      
      // Add unique classes to navigation buttons for this specific slider
      if (nextButton) nextButton.classList.add(`slider__btn__next--${index}`)
      if (prevButton) prevButton.classList.add(`slider__btn__prev--${index}`)
      if (pagination) pagination.classList.add(`swiper-pagination--${index}`)
      
      // Initialize Swiper for this specific container
      new Swiper(container, {
        loop: false,
        autoplay: false,
        pagination: {
          el: `.swiper-pagination--${index}`,
          clickable: true,
        },
        navigation: {
          nextEl: `.slider__btn__next--${index}`,
          prevEl: `.slider__btn__prev--${index}`,
        },
        breakpoints: {
          280: {
            slidesPerView: 1.2,
            spaceBetween: 11,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 11,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 11,
          },
        },
      })
    })
  }, 600)
}

export function myGreetingsliderfivetwohalf() {
  // Get all slider containers
  const sliderContainers = document.querySelectorAll('.sliderfivetwohalf')
  
  // Initialize each slider independently
  sliderContainers.forEach((container, index) => {
    // Add unique identifier to this slider if not already present
    if (!container.dataset.swiperIndex) {
      container.dataset.swiperIndex = index
    }
    
    // Find the navigation buttons within the closest parent section
    const parentSection = container.closest('.destinations') || container.closest('[class*="section"]') || container.parentElement
    const nextButton = parentSection?.querySelector('.slider__btn__next')
    const prevButton = parentSection?.querySelector('.slider__btn__prev')
    const pagination = parentSection?.querySelector('.swiper-pagination')
    
    // Add unique classes to navigation buttons for this specific slider
    if (nextButton) nextButton.classList.add(`slider__btn__next--${index}`)
    if (prevButton) prevButton.classList.add(`slider__btn__prev--${index}`)
    if (pagination) pagination.classList.add(`swiper-pagination--${index}`)
    
    // Initialize Swiper for this specific container
    new Swiper(container, {
      loop: false,
      autoplay: false,
      pagination: {
        el: `.swiper-pagination--${index}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.slider__btn__next--${index}`,
        prevEl: `.slider__btn__prev--${index}`,
      },
      breakpoints: {
        280: {
          slidesPerView: 2.2,
          spaceBetween: 11,
        },
        320: {
          slidesPerView: 2.2,
          spaceBetween: 11,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: 11,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 11,
        },
      },
    })
  })
}

export function myGreetingsliderfourtwohalf() {
  var swiper = new Swiper('.sliderfourtwohalf', {
    loop: false,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.tour_masters .slider__btn__next',
      prevEl: '.tour_masters .slider__btn__prev',
    },
   
    breakpoints: {
      280: {
        slidesPerView: 2.2,
        spaceBetween: 11,
      },
      320: {
        slidesPerView: 2.2,
        spaceBetween: 11,
      },
      768: {
        slidesPerView: 3.3,
        spaceBetween: 11,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 11,
      },
    },
  })
}

export function myGreetingsliderfouronehalf() {
  var swiper = new Swiper('.sliderfouronehalf', {
    autoplay: false,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.destination_style .slider__btn__next',
      prevEl: '.destination_style .slider__btn__prev',
    },
  
    breakpoints: {
      280: {
        slidesPerView: 1.2,
        spaceBetween: 11,
      },
      800: {
        slidesPerView: 2.5,
        spaceBetween: 11,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 11,
      },
    },
  })
}

export function myGreetingslidersixtwohalf() {
  
  // Get all slider containers
  const sliderContainers = document.querySelectorAll('.slidersixtwohalf')
 
  if (sliderContainers.length === 0) {
    return
  }
  
  // Initialize each slider independently
  sliderContainers.forEach((container, index) => {
   
    
    // Add unique identifier to this slider if not already present
    if (!container.dataset.swiperIndex) {
      container.dataset.swiperIndex = index
    }
    
    // Find the navigation buttons within the closest parent section
    const parentSection = container.closest('.destination_style') || container.closest('[class*="section"]') || container.parentElement
    const nextButton = parentSection?.querySelector('.slider__btn__next')
    const prevButton = parentSection?.querySelector('.slider__btn__prev')
    const pagination = parentSection?.querySelector('.swiper-pagination')
    
 
    
    // Add unique classes to navigation buttons for this specific slider
    if (nextButton) nextButton.classList.add(`slider__btn__next--sixtwohalf-${index}`)
    if (prevButton) prevButton.classList.add(`slider__btn__prev--sixtwohalf-${index}`)
    if (pagination) pagination.classList.add(`swiper-pagination--sixtwohalf-${index}`)
    
    // Initialize Swiper for this specific container
    const swiperInstance = new Swiper(container, {
      autoplay: false,
      loop: false,
      pagination: {
        el: `.swiper-pagination--sixtwohalf-${index}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.slider__btn__next--sixtwohalf-${index}`,
        prevEl: `.slider__btn__prev--sixtwohalf-${index}`,
      },
      breakpoints: {
        280: {
          slidesPerView: 2.2,
          spaceBetween: 11,
        },
        800: {
          slidesPerView: 2.5,
          spaceBetween: 11,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 11,
        },
      },
    })
    
    
  })
}



export function copyCodeClipBoard(id) {
  var copyText = document.getElementById(id).innerHTML
  navigator.clipboard.writeText(copyText)
}

export function lazyyoutube() {
  document.querySelectorAll('.lazy-youtube').forEach(function (el) {
    el.addEventListener('click', function () {
      const videoURL = el.getAttribute('data-url') + '?autoplay=1'
      const iframe = document.createElement('iframe')
      iframe.setAttribute('width', '550')
      iframe.setAttribute('height', '300')
      iframe.setAttribute('src', videoURL)
      iframe.setAttribute('frameborder', '0')
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      )
      iframe.setAttribute('allowfullscreen', '')
      el.innerHTML = ''
      el.appendChild(iframe)
    })
  })
}


// ---------------------bookingbash-------------------------------

// export function myGreetingslidersixtwohalfbv() {
  
//   // Get all slider containers
//   const sliderContainers = document.querySelectorAll('.slidersixtwohalfbv')
 
//   if (sliderContainers.length === 0) {
//     return
//   }
  
//   // Initialize each slider independently
//   sliderContainers.forEach((container, index) => {
   
    
//     // Add unique identifier to this slider if not already present
//     if (!container.dataset.swiperIndex) {
//       container.dataset.swiperIndex = index
//     }
    
//     // Find the navigation buttons within the closest parent section
//     const parentSection = container.closest('.destination_style') || container.closest('[class*="section"]') || container.parentElement
//     const nextButton = parentSection?.querySelector('.slider__btn__next')
//     const prevButton = parentSection?.querySelector('.slider__btn__prev')
//     const pagination = parentSection?.querySelector('.swiper-pagination')
    
 
    
//     // Add unique classes to navigation buttons for this specific slider
//     if (nextButton) nextButton.classList.add(`slider__btn__next--sixtwohalf-${index}`)
//     if (prevButton) prevButton.classList.add(`slider__btn__prev--sixtwohalf-${index}`)
//     if (pagination) pagination.classList.add(`swiper-pagination--sixtwohalf-${index}`)
    
//     // Initialize Swiper for this specific container
//     const swiperInstance = new Swiper(container, {
//       autoplay: false,
//       loop: false,
//       pagination: {
//         el: `.swiper-pagination--sixtwohalf-${index}`,
//         clickable: true,
//       },
//       navigation: {
//         nextEl: `.slider__btn__next--sixtwohalf-${index}`,
//         prevEl: `.slider__btn__prev--sixtwohalf-${index}`,
//       },
//       breakpoints: {
//         280: {
//           slidesPerView: 2.2,
//           spaceBetween: 20,
//         },
//         800: {
//           slidesPerView: 2.5,
//           spaceBetween: 20,
//         },
//         1024: {
//           slidesPerView: 6,
//           spaceBetween: 30,
//         },
//       },
//     })
    
    
//   })
// }

export function myGreetingslidersixtwohalfbv() {
  const sliderContainers = document.querySelectorAll('.slidersixtwohalfbv')

  if (sliderContainers.length === 0) return

  sliderContainers.forEach((container, index) => {
    if (!container.dataset.swiperIndex) {
      container.dataset.swiperIndex = index
    }

    const parentSection =
      container.closest('.destination_style') ||
      container.closest('[class*="section"]') ||
      container.parentElement

    const nextButton = parentSection?.querySelector('.slider__btn__next')
    const prevButton = parentSection?.querySelector('.slider__btn__prev')
    const pagination = parentSection?.querySelector('.swiper-pagination')

    const slides = container.querySelectorAll('.swiper-slide')

    // 👉 ONLY show arrows if slides > 6
    const showNavigation = slides.length > 5

    if (nextButton) nextButton.style.display = showNavigation ? 'flex' : 'none'
    if (prevButton) prevButton.style.display = showNavigation ? 'flex' : 'none'

    // Unique classes
    if (nextButton) nextButton.classList.add(`slider__btn__next--sixtwohalf-${index}`)
    if (prevButton) prevButton.classList.add(`slider__btn__prev--sixtwohalf-${index}`)
    if (pagination) pagination.classList.add(`swiper-pagination--sixtwohalf-${index}`)

    new Swiper(container, {
      autoplay: false,
      loop: false,
      pagination: {
        el: `.swiper-pagination--sixtwohalf-${index}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.slider__btn__next--sixtwohalf-${index}`,
        prevEl: `.slider__btn__prev--sixtwohalf-${index}`,
      },
      breakpoints: {
        280: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        800: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 30,
        },
      },
    })
  })
}


export function myGreetingsliderfouronehalfbv() {
  const sliderContainers = document.querySelectorAll('.sliderfouronehalfbv');

  sliderContainers.forEach((container, index) => {
    const parentSection =
      container.closest('.destination_style') ||
      container.closest('[class*="section"]') ||
      container.parentElement;

    const nextButton = parentSection?.querySelector('.slider__btn__next');
    const prevButton = parentSection?.querySelector('.slider__btn__prev');
    const pagination = parentSection?.querySelector('.swiper-pagination');

    // Add unique classes for each slider
    if (nextButton) nextButton.classList.add(`slider__btn__next--fouronehalf-${index}`);
    if (prevButton) prevButton.classList.add(`slider__btn__prev--fouronehalf-${index}`);
    if (pagination) pagination.classList.add(`swiper-pagination--fouronehalf-${index}`);

    // Initialize Swiper for this container
    new Swiper(container, {
      autoplay: false,
      loop: false,
      pagination: {
        el: `.swiper-pagination--fouronehalf-${index}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.slider__btn__next--fouronehalf-${index}`,
        prevEl: `.slider__btn__prev--fouronehalf-${index}`,
      },
      breakpoints: {
        280: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });
}


export function myGreetingsliderfourtwohalfbv() {
  const sliderContainers = document.querySelectorAll('.sliderfourtwohalfbv');

  sliderContainers.forEach((container, index) => {
    const parentSection =
      container.closest('.tour_masters') ||
      container.closest('[class*="section"]') ||
      container.parentElement;

    const nextButton = parentSection?.querySelector('.slider__btn__next');
    const prevButton = parentSection?.querySelector('.slider__btn__prev');
    const pagination = parentSection?.querySelector('.swiper-pagination');

    // Add unique identifiers to prevent cross-control
    if (nextButton) nextButton.classList.add(`slider__btn__next--fourtwohalf-${index}`);
    if (prevButton) prevButton.classList.add(`slider__btn__prev--fourtwohalf-${index}`);
    if (pagination) pagination.classList.add(`swiper-pagination--fourtwohalf-${index}`);

    // Initialize Swiper for this specific slider
    new Swiper(container, {
      loop: false,
      autoplay: false,
      pagination: {
        el: `.swiper-pagination--fourtwohalf-${index}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.slider__btn__next--fourtwohalf-${index}`,
        prevEl: `.slider__btn__prev--fourtwohalf-${index}`,
      },
      breakpoints: {
        280: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        800: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });
}

export function myGreetingsliderfivetwohalfbv() {
  // Get all slider containers
  const sliderContainers = document.querySelectorAll('.sliderfivetwohalfbv')
  
  // Initialize each slider independently
  sliderContainers.forEach((container, index) => {
    // Add unique identifier to this slider if not already present
    if (!container.dataset.swiperIndex) {
      container.dataset.swiperIndex = index
    }
    
    // Find the navigation buttons within the closest parent section
    const parentSection = container.closest('.destinations') || container.closest('[class*="section"]') || container.parentElement
    const nextButton = parentSection?.querySelector('.slider__btn__next')
    const prevButton = parentSection?.querySelector('.slider__btn__prev')
    const pagination = parentSection?.querySelector('.swiper-pagination')
    
    // Add unique classes to navigation buttons for this specific slider
    if (nextButton) nextButton.classList.add(`slider__btn__next--${index}`)
    if (prevButton) prevButton.classList.add(`slider__btn__prev--${index}`)
    if (pagination) pagination.classList.add(`swiper-pagination--${index}`)
    
    // Initialize Swiper for this specific container
    new Swiper(container, {
      loop: false,
      autoplay: false,
      pagination: {
        el: `.swiper-pagination--${index}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.slider__btn__next--${index}`,
        prevEl: `.slider__btn__prev--${index}`,
      },
      breakpoints: {
        280: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        800: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
      },
    })
  })
}

export function myGreetingsliderthreeonehalfbv() {
  // Get all slider containers
  const sliderContainers = document.querySelectorAll('.sliderthreeonehalfbv')
  
  // Initialize each slider independently
  sliderContainers.forEach((container, index) => {
    // Add unique identifier to this slider if not already present
    if (!container.dataset.swiperIndex) {
      container.dataset.swiperIndex = index
    }
    
    // Find the navigation buttons within the closest parent section
    const parentSection = container.closest('.holidays') || container.closest('[class*="section"]') || container.parentElement
    const nextButton = parentSection?.querySelector('.slider__btn__next')
    const prevButton = parentSection?.querySelector('.slider__btn__prev')
    const pagination = parentSection?.querySelector('.swiper-pagination')
    
    // Add unique classes to navigation buttons for this specific slider
    if (nextButton) nextButton.classList.add(`slider__btn__next--${index}`)
    if (prevButton) prevButton.classList.add(`slider__btn__prev--${index}`)
    if (pagination) pagination.classList.add(`swiper-pagination--${index}`)
    
    // Initialize Swiper for this specific container
    new Swiper(container, {
      loop: false,
      autoplay: false,
      pagination: {
        el: `.swiper-pagination--${index}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.slider__btn__next--${index}`,
        prevEl: `.slider__btn__prev--${index}`,
      },
      breakpoints: {
        280: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    })
  })
}
